import React from "react";
import { Trophy } from "@phosphor-icons/react";

export const FinalizeDialog = ({ sk, statPlayers }) => {
  const { game, teamOf, home, away, week, setWeek, pog, setPog, adds, saving, setFinalizing, confirmFinalize } = sk;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setFinalizing(false)}>
      <div className="bg-[#121212] border border-white/10 w-full max-w-md" onClick={(e) => e.stopPropagation()} data-testid="finalize-dialog">
        <div className="px-6 py-4 border-b border-white/10">
          <h3 className="font-display text-2xl uppercase">Finalize Game</h3>
        </div>
        <div className="p-6 space-y-4">
          <div className="text-center font-display text-3xl">
            {teamOf(game.home_team_id)?.name} <span className="text-[#FF5722]">{home}</span> — <span className="text-[#FF5722]">{away}</span> {teamOf(game.away_team_id)?.name}
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wide text-white/60 mb-1.5">Week Number</label>
            <input type="number" min="1" value={week} onChange={(e) => setWeek(e.target.value)} data-testid="finalize-week-input" placeholder="e.g. 1" className="w-full bg-[#1A1A1A] border border-white/15 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF5722]" />
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wide text-white/60 mb-1.5"><Trophy size={13} weight="fill" className="inline text-[#FF5722] mb-0.5" /> Player of the Game</label>
            <select value={pog} onChange={(e) => setPog(e.target.value)} data-testid="finalize-pog-select" className="w-full bg-[#1A1A1A] border border-white/15 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF5722]">
              <option value="">Auto (top performer)</option>
              {statPlayers.map((p) => (
                <option key={p.id} value={p.id}>{`${p.number != null ? `#${p.number} ` : ""}${p.name} — ${adds[p.id]?.pts || 0}pts`}</option>
              ))}
            </select>
          </div>
          <p className="text-white/40 text-xs">Finalizing locks {statPlayers.length} player stat line{statPlayers.length === 1 ? "" : "s"}. An admin can unlock later to make corrections.</p>
          <div className="flex gap-3 pt-2">
            <button onClick={() => setFinalizing(false)} data-testid="finalize-cancel-btn" className="flex-1 border border-white/15 hover:border-white text-white/80 font-bold uppercase tracking-wide py-3 transition-all duration-200">Cancel</button>
            <button onClick={confirmFinalize} disabled={saving} data-testid="finalize-confirm-btn" className="flex-1 bg-[#FF5722] hover:bg-[#FF7043] disabled:opacity-50 text-black font-bold uppercase tracking-wide py-3 transition-all duration-200">{saving ? "Saving..." : "Confirm & Finalize"}</button>
          </div>
        </div>
      </div>
    </div>
  );
};
